import { ERROR_INVALID_REDIRECT_URL, ERROR_LOGIN } from './constants'

export const invalidRedirectUri = 'Invalid parameter: redirect_uri'

export const kcAlertMessage = (kcMessage: string) => {
  switch (kcMessage) {
    case invalidRedirectUri:
      return ERROR_INVALID_REDIRECT_URL
    default:
      return ERROR_LOGIN
  }
}
